module.exports = __webpack_public_path__ + "static/media/Anatomy_Good.33a8bacb.png";